import { render, staticRenderFns } from "./TeacherSchedule.vue?vue&type=template&id=485c9639&scoped=true"
import script from "./TeacherSchedule.vue?vue&type=script&lang=js"
export * from "./TeacherSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485c9639",
  null
  
)

export default component.exports